import { AfterContentInit, AfterViewInit, Component, Inject, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import grapesjs from 'grapesjs';
import 'grapesjs-preset-webpage';
// import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs-preset-newsletter';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { GrapesJsPopupComponent } from '../grapes-js-popup/grapes-js-popup.component';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { NotifierService } from 'angular-notifier';
import { SaveTemplateDialogComponent } from '../save-template-dialog/save-template-dialog.component';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-grapesjs-editor',
  templateUrl: './grapesjs-editor.component.html',
  styleUrls: ['./grapesjs-editor.component.css']
})
export class GrapesjsEditorComponent implements OnInit, AfterViewInit {

  private editor: any;
  private template: any;
  minTemplateName: any;
  status: any;
  minuteJSON: any;
  updateTemplate = false;
  templateResponse: any;
  htmlContent: any;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  constructor(private readonly breakpointObserver: BreakpointObserver, private notifierService: NotifierService, private sideNav: SideNavServiceService, private meetingService: MeetingService, private _mdr: MatDialogRef<GrapesjsEditorComponent>, @Inject(MAT_DIALOG_DATA) data: any, private globals: Globals, public dialog: MatDialog, private spinner: NgxSpinnerService,) {
  }
  ngOnInit(): void {
    this.initGrapesJS();
  }

  ngAfterViewInit(): void {
    document.getElementById("visibility")?.click();
  }
  private initGrapesJS(): void {
    this.editor = grapesjs.init({
      container: '#gjs',
      fromElement: true,
      height: '700px',
      width: 'auto',
      storageManager: false,
      panels: { defaults: [] },
      plugins: ['gjs-preset-webpage', 'gjs-preset-newsletter'],
      pluginsOpts: {
        'gjs-preset-webpage': {
          blocksBasicOpts: {
            blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
            flexGrid: 1,
          },
        },
        'gjs-preset-newsletter': {
        }
      },
    })
    this.editor.addComponents('<div class="gjs-pn-views-container"></div>');
    // gjs-pn-btn fa fa-desktop
    this.editor.Panels.removePanel('devices-c');
    this.editor.Panels.removePanel('commands');
this.editor.StyleManager.addSector('Typography', {
      name: 'Typography',
      open: true,
      buildProps: ['font-family', 'font-size', 'color', 'text-align'],
      properties: [
        {
          name: 'Font',
          property: 'font-family',
          type: 'select',
          options: [
            { value: 'Arial, sans-serif', name: 'Arial' },
            { value: 'Verdana, sans-serif', name: 'Verdana' },
            { value: 'Helvetica, sans-serif', name: 'Helvetica' },
            { id: '"Segoe UI", Calibri, sans-serif', name: 'Segoe UI' },
            { value: '"Times New Roman", serif', name: 'Times New Roman' },
            { value: 'Georgia, serif', name: 'Georgia' },
            { value: 'Courier New, monospace', name: 'Courier New' },
            { value: 'Tahoma, sans-serif', name: 'Tahoma' },
            { value: '"Trebuchet MS", sans-serif', name: 'Trebuchet MS' },
            { value: '"Lucida Sans Unicode", sans-serif', name: 'Lucida Sans Unicode' },
            { value: '"Lucida Console", monospace', name: 'Lucida Console' },
            { value: '"Comic Sans MS", cursive, sans-serif', name: 'Comic Sans MS' },
            { value: '"Arial Black", sans-serif', name: 'Arial Black' },
            { value: '"Impact", sans-serif', name: 'Impact' },
            { value: '"Gill Sans", sans-serif', name: 'Gill Sans' },
            { value: '"Palatino Linotype", serif', name: 'Palatino Linotype' },
            { value: '"Book Antiqua", serif', name: 'Book Antiqua' },
            { value: '"Candara", sans-serif', name: 'Candara' },
            { value: '"Calibri", sans-serif', name: 'Calibri' },
            { value: '"Open Sans", sans-serif', name: 'Open Sans' },
            { value: '"Roboto", sans-serif', name: 'Roboto' },
            { value: '"Lato", sans-serif', name: 'Lato' },
            { value: '"Oswald", sans-serif', name: 'Oswald' },
            { value: '"Montserrat", sans-serif', name: 'Montserrat' },
            { value: '"Noto Sans", sans-serif', name: 'Noto Sans' },
            { value: '"Ubuntu", sans-serif', name: 'Ubuntu' },
            { value: '"Merriweather", serif', name: 'Merriweather' },
            { value: '"PT Serif", serif', name: 'PT Serif' },
            { value: '"Droid Sans", sans-serif', name: 'Droid Sans' },
          ],
          //defaults: 'Calibri' // Default font-family
        },
      ],
    });
    const style = document.createElement('style');
    style.innerHTML = `
    .gjs-pn-views-container { background-color: rgba(73, 102, 218, 0.87) !important;   border-color: blue !important;}
    .gjs-pn-buttons { background-color: rgba(73, 102, 218, 0.87) !important;   border-color: blue !important; }
    .gjs-pn-btn {color : white !important; border-color: blue !important;}
    .gjs-selected{  outline-color: greenyellow !important;};
    .gjs-blocks-c{ color: rgba(73, 102, 218, 0.87) !important; }
    .gjs-pn-panel{background-color: rgba(73, 102, 218, 0.87) !important;}
    .gjs-title {background-color: rgba(73, 102, 218, 0.87) !important;}
    .gjs-one-bg{background-color: rgba(73, 102, 218, 0.87) !important;}
    .gjs-frame{height: 100%;width: 50%;}.color-blue{color:#0066cc;}`;

    document.head.appendChild(style);
    this.addCustomBlocks();
    //this.loadTemplate();
    document.getElementById("visibility")?.click();


  }

  removeDefaultBlocks(): void {
    const bm = this.editor.BlockManager;
    // List of block IDs to remove
    const blocksToRemove = ['column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video']; // Example IDs, replace with actual ones
    blocksToRemove.forEach(id => {
      bm.remove(id);
    });
  }



  private addCustomBlocks(): void {
    document.getElementById("visibility")?.click();
    // Meeting Description
    this.editor.BlockManager.add('meetingTitle', {
      label: 'Meeting Title',
      content: `<h3 class="meetingTitle" style="color:#63b934;font-weight:600;" id="meeting_title">{{Meeting Title}}</h3>`,
      category: 'Meeting_Description',
      attributes: { class: 'fa fa-window-minimize' }
    });

    this.editor.BlockManager.add('Facilitator', {
      label: 'Facilitator',
      content: `<div class="meetingFacilitator"  id="Facilitator"><span class="bold" style="font-weight:600;">Facilitator: </span> <span class="Facilitator_span" id="Facilitator_span">{{Facilitator}}</span></div>`,
      category: 'Meeting_Description',
      attributes: { class: 'fa fa-user-circle-o' }
    });

    this.editor.BlockManager.add('NoteTaker', {
      label: 'NoteTaker',
      content: `<div class="meetingNoteTaker"  id="NoteTaker"><span class="bold" style="font-weight:600;">NoteTaker: </span> <span class="NoteTaker_span" id="NoteTaker_span">{{NoteTaker}}</span></div>`,
      category: 'Meeting_Description',
      attributes: { class: 'fa fa-pencil-square-o' }
    });

    this.editor.BlockManager.add('Meeting_type', {
      label: 'Meeting Type',
      content: `<div class="MeetingType"  id="MeetingType"> <span class="bold" style="font-weight:600;">Meeting Type: </span> <span class="meeting_type_span" id="meeting_type_span">{{Meeting Type}}</span></div>`,
      category: 'Meeting_Description',
      attributes: { class: 'fa fa-hand-pointer-o' }
    });

    this.editor.BlockManager.add('meetingDate', {
      label: 'Meeting Date',
      content: `<div class="meetingDate"><span style=" color: 0066cc; font-weight:600;">Meeting held on: </span> <span class="meeting_Date" id="meeting_Date">{{Meeting Date}}</span></div>`,
      category: 'Meeting_Description',
      attributes: { class: 'fa fa fa-calendar' }
    });

    this.editor.BlockManager.add('meetingTime', {
      label: 'Meeting Time',
      content: `<div class="meetingTime" placeholder='meetingTime' id="meeting_time"><span class="bold color-blue" style="color:#0066cc;font-weight:600;">From: </span> <span id="from_time" class="from_time">{{From Time}}</span>   <span class="bold color-blue" style= "color:#0066cc;font-weight:600;"> To: </span> <span id="to_time" class="to_time">{{To Time}}</span></div>`,
      category: 'Meeting_Description',
      attributes: { class: 'fa fa-clock-o' }
    });

    this.editor.BlockManager.add('meetingLocation', {
      label: 'Meeting Location',
      content: '<div class="location" id="meeting_location" id="meeting_location"> <span class="bold" style="font-weight:600;"> Location: </span> <span class="meeting_location_span" id="meeting_location_span">{{Location}}</div>',
      category: 'Meeting_Description',
      attributes: { class: 'fa fa-location-arrow' }
    })

    this.editor.BlockManager.add('participant', {
      label: 'Participants',
      content: '<div class="participant"><span class="bold" style="font-weight:600;">In attendance: </span><span class="present" id="present">{{Attendees}}</span>    <span class="bold" style="font-weight:600;"> Absent: </span> <span class="absent" id="absent">{{Absentees}}</span></div>',
      category: 'Meeting_Description',
      attributes: { class: 'fa fa-users' }
    })



    // Meeting Minutes category
    this.editor.BlockManager.add('agenda', {
      label: 'Agenda',
      content: '<div class="agenda" id="agenda_with_minutes">{{Agenda With Minutes}}</div>',
      category: 'Meeting_Minutes',
      attributes: { class: 'fa fa-database' }
    })

    this.editor.BlockManager.add('agenda-block', {
      label: 'Custom_Agenda',
      content: `<div id="agenda-block" class="agenda-block">
    <agenda id="agenda">{{Agenda}}</agenda>
    <ul data-agenda="list">
    <li><div ><note id="note" style="width : 50px;" contenteditable="true">{{Note}}</note></div></li>
    <li><div ><task id="task" style="width : 50px;" contenteditable="true">{{Task}}</task></div></li>
    <li><div ><decision id="decision" style="width : 50px;" contenteditable="true">{{Decision}}</decision></div></li>
    </ul>
    </div>`,
      category: 'Meeting_Minutes',
      attributes: { class: 'fa fa-clone' }
    });

    this.editor.BlockManager.add('note', {
      label: 'Notes',
      content: '<div class="note" id="meeting_note">{{Note}}</div>',
      category: 'Meeting_Minutes',
      attributes: { class: 'fa fa-sticky-note' }
    })
    this.editor.BlockManager.add('task', {
      label: 'Tasks',
      content: '<div class="task" id="meeting_task">{{Task}}</div>',
      category: 'Meeting_Minutes',
      attributes: { class: 'fa fa-tasks' }
    })
    this.editor.BlockManager.add('decision', {
      label: 'Decisions',
      content: '<div class="decision" id="meeting_decision">{{Desision}}</div>',
      category: 'Meeting_Minutes',
      attributes: { class: 'fa fa-thumbs-up', style: { 'background-color': 'rgba(73, 102, 218, 0.87) !important;' } }
    })


    // Extra plugins block
    this.editor.BlockManager.add('horizontal-line', {
      label: 'Horizontal Line',
      content: '<hr style="color:solid black;">',
      category: 'Basic',
      attributes: { class: 'fa fa-arrows-h' }
    })

    this.editor.BlockManager.add('vertical-line', {
      label: 'Vertical Line',
      content: '    <div class= "vertical"   style="border-left: 2px solid black;height: 100%;"></div>',
      category: 'Basic',
      attributes: { class: 'fa fa-arrows-v' }
    });
    document.getElementById("visibility")?.click();

  }

  removeDefaultCategories(editor: any) {
    const blockManager = editor.BlockManager;
    const categories = blockManager.getCategories();
    const categoriesToRemove = ['basic'];
    const updatedCategories = categories.filter((category: any) =>
      !categoriesToRemove.includes(category.id)
    );
    blockManager.setCategories([]);
    updatedCategories.forEach((category: any) => blockManager.addCategory(category));
  }

  export() {
    const html = this.htmlContent;
    const css = this.editor.getCss();
    var orgCode = localStorage.getItem("orgCode");

    let saveTemplateDialog = this.dialog.open(GrapesJsPopupComponent, {
      data: {
        templateData: { html: html, css: css },
        option: 'save'
      },
      //   left : "0%"
      // },
      // panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      // height : "60vh",
      maxWidth: "100%",
      // maxHeight: "100vh",
      width: "50%"
    });
    // const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //   if(size.matches){
    //     saveTemplateDialog.updateSize('50%','');
    //   }
    // })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
      else {
        saveTemplateDialog.updateSize('50%', 'auto');
      }
    }); saveTemplateDialog.afterClosed().subscribe((response: any) => {
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });


 
  }


  update() {
    const html = this.editor.getHtml();
    const css = this.editor.getCss();
    const formatedHTML = this.exportToHTMLWithCSS();
    let saveTemplateDialog = this.dialog.open(GrapesJsPopupComponent, {
      data: {
        templateData: { html: html, css: css, formatedHTML: formatedHTML },
        templateResponse: this.templateResponse,
        option: 'update'
      },
      //   left : "0%"
      // },
      // panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      // height : "60vh",
      maxWidth: "100%",
      // maxHeight: "100vh",
      width: "50%"
    });
    // const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //   if(size.matches){
    //     saveTemplateDialog.updateSize('50%','');
    //   }
    // })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
      else {
        saveTemplateDialog.updateSize('50%', 'auto');
      }
    });
    saveTemplateDialog.afterClosed().subscribe((response: any) => {
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });

  }

  editTemplate() {
    var req = {
      createdBy: localStorage.getItem("userId")
    }
    let saveTemplateDialog = this.dialog.open(GrapesJsPopupComponent, {
      data: {
        option: 'edit',
      },
      disableClose: false,
      maxWidth: "100%",
      width: "50%"
    });
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
      else {
        saveTemplateDialog.updateSize('50%', 'auto');
      }
    });
    saveTemplateDialog.afterClosed().subscribe((response: any) => {
      if (response && (response.value.html !==null || response.value.css !== null)) {
      this.templateResponse = response.value;
      this.editor.setComponents(response.value.html);
      this.editor.setStyle(response.value.css);
      this.updateTemplate = true;
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      }
    });
  }

  // filterCondition(event: any) {
  
  //    this.minuteJSON.minTemplateId = event.value.minTemplateId;
  //   this.meetingService.loadContent(this.minuteJSON).subscribe((resp:any)=>{
  
  //     this.editor.setComponents(resp.body.html);
  //    this.editor.setStyle(resp.body.css);
  //   })
  // }

  blankTemplate() {
    this.editor.DomComponents.clear(); // Clear components
    this.editor.CssComposer.clear();  // Clear styles
    this.editor.UndoManager.clear(); // Clear undo history
    this.updateTemplate = false;
  }

  public convertToPDF() {
    const blob = new Blob([this.htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'content.html';
    a.click();
    URL.revokeObjectURL(url);
  }

  exportToHTMLWithCSS(): string {
    const htmlContent = this.editor.getHtml();
    const cssContent = this.editor.getCss();
    return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>GrapesJS Export</title>
    <style>${cssContent}</style>
</head>
<body>
    ${this.htmlContent}
</body>
</html>`;
  }

  // sendMoMDraft(){
  //   this.dialog.open(ConfirmDialogComponent, {
  //     data: {
  //       dialogTitle : "Confirmation",
  //       dialogContent : "The MoM will be sent to all participant(s). Please confirm?"
  //     },
  //   }).afterClosed().subscribe(response => {
  //     let dialogResponse = response
  //     if(dialogResponse == true){

  //       const htmlContent = this.exportToHTMLWithCSS();
  //       this.minuteJSON =this.constructReq();
  //       //this.minuteJSON.sendDraft="Y";
  //       this.minuteJSON.previewFlag="N";
  //       this.minuteJSON.htmlContent = htmlContent;

  //       this.meetingService.sendMomDraft(this.minuteJSON).subscribe((response:any)=>{

  //         document.getElementById("resetbtn")?.click()
  //         this.notifierService.show({
  //           type: 'success',
  //           message: 'The MoM draft has been sent successfully'
  //         });
  //       })


  //     }
  //   })
  // }


  loadInlineCss() {
    this.editor.on('change:changesCount', (e: any) => {
      this.htmlContent = this.editor.runCommand('gjs-get-inlined-html')
 
    });
    this.editor.on('component:add', (component: any) => {
      const uniqueClass = `block-${Date.now()}`;
      component.addClass(uniqueClass);
 
    });
  
    this.editor.on('component:add', (component:any) => {
      if (component.is('text')) {
        // Add a class instead of inline style
        if (!component.getClasses().includes('default-text-style')) {
          component.addClass('default-text-style');
        }
      }
    });
    this.editor.addComponents(`
      <style>
          body {
              font-family: "Segoe UI", Calibri, sans-serif;
          }
      </style>
  `);
    const cssRules = `
  .default-text-style {
    font-family: Georgia;
  }
`;
  this.editor.addStyle(cssRules);   
  }

  saveTemplate() {
    const html = this.htmlContent;
    const css = this.editor.getCss();
    const formatedHTML = this.exportToHTMLWithCSS();
    // const images = this.editor.getComponents().filter((component:any) => component.is('image')).map((component:any) => component.get('src'));
    
    let saveTemplateDialog = this.dialog.open(GrapesJsPopupComponent, {
      data: {
        templateData: { html: html, css: css, formatedHTML: formatedHTML },
        option: 'save'
      },        // position : {
      //   left : "0%"
      // },
      // panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      // height : "60vh",
      maxWidth: "100%",
      // maxHeight: "100vh",
      width: "50%"
    });
    // const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //   if(size.matches){
    //     saveTemplateDialog.updateSize('50%','');
    //   }
    // })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
      else {
        saveTemplateDialog.updateSize('50%', 'auto');
      }
    });
    saveTemplateDialog.afterClosed().subscribe((data) => {
      // mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }

  imageUpload(files: FileList) {
    // const input = img.target as HTMLInputElement;
    // if (input.files) {
    //   const file = input.files[0];
    //   const reader = new FileReader();
    //   reader.onload = (e: any) => {
    //     const imageUrl = e.target.result;
    //     this.addImageComponent(imageUrl);
    //   };
    //   reader.readAsDataURL(file);
    // }
    if (files.length > 0) {
      const file = files[0]; // Get the first file
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const imageUrl = event.target.result;

        // Upload to the server if needed
        // this.contentService.uploadAsset(imageUrl).subscribe(response => {
        // On successful upload, add the image to the Asset Manager
        this.editor.AssetManager.add({ src: imageUrl });
        //    }, error => {
        //    console.error('Upload error:', error);
        //  });
      };

      reader.readAsDataURL(file); // Read the file as a Data URL
    }
  }

  addImageComponent(src: string) {
 
    this.editor.addComponents({
      type: 'image',
      src: src,
    });
  }

  close() {
    this._mdr.close()
  }

}
